import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import mobLogo from 'assets/images/new/mobLogo.png'

const StyledComponent = styled(({css, sport_title, staticContext, match, ...rest}) => (
  <a {...rest} />))`

  color: #000;
  cursor: pointer;
  display: inline-block;
  font-family: ${p => p.theme.fontFamilyHeader};
  font-size: 16px;
  font-variant-ligatures: no-common-ligatures;
  font-weight: 700;
  grid-area: logo;
  line-height: 20px;
  outline: none;
  position: relative;
  text-decoration: none;
  white-space: nowrap;

  @media (min-width: ${p => p.theme.mobileSize}) {
    font-size: 18px;
    line-height: 24px;
  }

  @media (min-width: ${p => p.theme.mobileLargeSize}) {
    font-size: 31px;
    line-height: 40px;
  }

  &:focus-visible {
    outline: ${p => p.theme.cBlue} 2px solid;
  }

  @media (min-width: ${props => props.theme.mediaTriggerWidth}) {
    margin: auto 0;
  }

  span.logo span {
    color: #00aeef;
  }

  ${p => p.css};
`

const _PageHeader_Logo_Image = (props) => <StyledComponent {...props} />
_PageHeader_Logo_Image.propTypes = {
  css: PropTypes.string,
}

export default _PageHeader_Logo_Image
